/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { companyAttribute } from '../models/companyAttribute';
import type { parametersFilter } from '../models/parametersFilter';
import type { parametersFilterCount } from '../models/parametersFilterCount';
import type { parametersFilterDelete } from '../models/parametersFilterDelete';
import type { responsesPartMeta } from '../models/responsesPartMeta';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CompanyAttributesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * count companyAttributes
   * Count companyAttributes (with filtering, pagination and limiting). You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * @param filter
   * @returns any Count of companyAttribute documents found. Wrapped in a JsonAPI root response with wrapped count result as data.
   * @throws ApiError
   */
  public getApiServiceorganizationsCompanyAttributesCount(
    filter?: parametersFilterCount,
  ): CancelablePromise<{
    data?: {
      count?: number;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/companyAttributes/count',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * find one companyAttribute
   * Find one companyAttribute by its unique identifier.
   * @param identifier companyAttribute unique identifier
   * @returns any One companyAttribute document found. Wrapped in a JsonAPI root response with document as data.
   * @throws ApiError
   */
  public getApiServiceorganizationsCompanyAttributes(
    identifier: string,
  ): CancelablePromise<{
    data?: companyAttribute;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/companyAttributes/{identifier}',
      path: {
        'identifier': identifier,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * replace one companyAttribute which exists or not
   * Replace one companyAttribute which exists or not
   * @param identifier companyAttribute unique identifier
   * @param requestBody
   * @returns any companyAttribute replaced. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public putApiServiceorganizationsCompanyAttributes(
    identifier: string,
    requestBody?: companyAttribute,
  ): CancelablePromise<{
    data?: companyAttribute;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/serviceorganizations/companyAttributes/{identifier}',
      path: {
        'identifier': identifier,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * partially update one existing companyAttribute
   * Partially update one existing companyAttribute
   * @param identifier companyAttribute unique identifier
   * @param requestBody
   * @returns any updated companyAttribute. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public patchApiServiceorganizationsCompanyAttributes(
    identifier: string,
    requestBody?: companyAttribute,
  ): CancelablePromise<{
    data?: companyAttribute;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/serviceorganizations/companyAttributes/{identifier}',
      path: {
        'identifier': identifier,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * delete one companyAttribute
   * Delete one companyAttribute
   * @param identifier companyAttribute unique identifier
   * @returns any delete status companyAttributes. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public deleteApiServiceorganizationsCompanyAttributes(
    identifier: string,
  ): CancelablePromise<{
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/serviceorganizations/companyAttributes/{identifier}',
      path: {
        'identifier': identifier,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * find many companyAttributes
   * Find many companyAttributes (with filtering, projection, pagination and limiting). You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * - To only return specific fields, use the projection query parameter. Usage is as follows: filter[fields][fieldName1]=true&filter[fields][fieldName2]=true.
   * @param filter
   * @returns any One or many companyAttribute documents found. Wrapped in a JsonAPI root response with collection of documents as data.
   * @throws ApiError
   */
  public getApiServiceorganizationsCompanyAttributes1(
    filter?: parametersFilter,
  ): CancelablePromise<{
    data?: Array<companyAttribute>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/companyAttributes',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * create one or multiple companyAttributes
   * Create one or multiple companyAttributes
   * @param requestBody
   * @returns any One or many companyAttribute documents created. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public postApiServiceorganizationsCompanyAttributes(
    requestBody?: (companyAttribute | Array<companyAttribute>),
  ): CancelablePromise<{
    data?: (companyAttribute | Array<companyAttribute>);
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceorganizations/companyAttributes',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * replace many companyAttributes which exists or not
   * Replace many companyAttributes which exists or not
   * @param requestBody
   * @returns any companyAttributes replaced. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public putApiServiceorganizationsCompanyAttributes1(
    requestBody?: Array<companyAttribute>,
  ): CancelablePromise<{
    data?: Array<companyAttribute>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/serviceorganizations/companyAttributes',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * partially update many existing companyAttribute
   * Partially update many existing companyAttribute
   * @param requestBody
   * @returns any companyAttributes updated. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public patchApiServiceorganizationsCompanyAttributes1(
    requestBody?: Array<companyAttribute>,
  ): CancelablePromise<{
    data?: Array<companyAttribute>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/serviceorganizations/companyAttributes',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * delete many companyAttributes
   * Delete many companyAttributes using filtering. You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * @param filter
   * @returns any delete status companyAttributes. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public deleteApiServiceorganizationsCompanyAttributes1(
    filter?: parametersFilterDelete,
  ): CancelablePromise<{
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/serviceorganizations/companyAttributes',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

}
